var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "-10 0 48 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.295 0.759766C22.549 2.88334 21.6854 4.97399 20.4154 6.50493C19.0946 8.01944 16.9779 9.17173 14.9289 9.0236C14.658 6.98233 15.6909 4.80937 16.8594 3.49243C18.1802 1.9944 20.4662 0.842076 22.295 0.759766ZM29.0348 12.991C28.8486 13.0898 24.9877 15.2956 25.0385 19.8226C25.0893 25.255 29.9154 27.0493 30 27.0658C29.9662 27.181 29.238 29.6503 27.4261 32.1525C25.9191 34.3584 24.3273 36.5148 21.8042 36.5478C20.6035 36.572 19.7955 36.2379 18.9546 35.8901C18.076 35.5268 17.1614 35.1486 15.7251 35.1486C14.2079 35.1486 13.2512 35.5371 12.3269 35.9125C11.5283 36.2368 10.7538 36.5514 9.66287 36.5972C7.25827 36.696 5.42947 34.2596 3.85467 32.0702C0.72196 27.609 -1.71647 19.5099 1.55167 13.9952C3.12647 11.2954 6.02217 9.55045 9.12097 9.5011C10.4849 9.47307 11.7944 9.98523 12.9412 10.4338C13.8162 10.7762 14.5964 11.0814 15.234 11.0814C15.7909 11.0814 16.5456 10.7906 17.4263 10.4512C18.822 9.91342 20.5342 9.25352 22.2784 9.43525C23.4637 9.46817 26.8504 9.89614 29.0348 12.991Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/appStore.c164302c33ed95bd7b72c2139241db93.svg";
export { ForwardRef as ReactComponent };